export const GET_CONFIG_REQUEST = 'GET_CONFIG_REQUEST';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAIL = 'GET_CONFIG_FAIL';
export const SET_CONFIG = 'SET_CONFIG';
